export interface DomainDomainValueT {
  id: number;
  domainId: number;
  value: string;
  code: string;
  description: string | null;
  order: number | null;
  parentDomainValueId: number | null;
}

export const DOMAIN_VALUES = {
  commune: "D-COM",
  neighborhood: "D-BARR",
  precedence: "D-PREC",
  street: "D-CALL",
  typeFront: "D-TFRN",
  typeRecollection: "D-TCOLL",
  typeAssociates: "D-TASC",
  powerBiDashboards: "D-POWERBI",
} as const;

export type DomainValues = (typeof DOMAIN_VALUES)[keyof typeof DOMAIN_VALUES];
